import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCreditCard = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 2,
	strokeLinecap: "round",
	strokeLinejoin: "round",
	className: "lucide lucide-credit-card-icon lucide-credit-card",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 20,
		height: 14,
		x: 2,
		y: 5,
		rx: 2
	}), /* @__PURE__ */ _jsx("line", {
		x1: 2,
		x2: 22,
		y1: 10,
		y2: 10
	})]
});
export default SvgCreditCard;
